<template>
    <div :class="tableView ? 'form-group form-check' : 'form-group form-check d-flex flex-column justify-content-center h-100 padding-bottom-12'">
        <div>
            <input type="hidden" :name="fieldData.code" :value="fieldValue ? 1 : 0">
            <input type="checkbox" :id="fieldData.code" v-model="fieldValue"
                   class="form-check-input" :disabled="!isEditible">
            <label v-if="!tableView" :for="fieldData.code" :class="tableView ? 'table-input' : 'form-check-label mb-0'">{{ fieldData['title_' + getLang()] }}
                <span class="input-group__required">{{ fieldData.required ? '*' : '' }}</span>
            </label>
        </div>
        <div v-if="!tableView && validationErrors">
            <span v-for="error in validationErrors" class="error-text d-block">{{ error }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'checkbox',
    props: {
        modelValue: Boolean,
        field: Object,
        isEditible: Boolean,
        oldData: {
            type: [String, Boolean],
            default: '',
        },
        tableView: Boolean,
        validationErrors: Object,
    },
    emits: ['update:modelValue'],
    data() {
        return {
            fieldData: {},
        };
    },
    mounted() {
        this.fieldData = this.field;
        const checked = this.oldData === 'true' || this.oldData === true || this.oldData === 'on' || this.oldData === '1';
        if (checked !== this.modelValue) {
            this.$emit('update:modelValue', checked);
        }
    },
    computed: {
        fieldValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    methods: {
        getLang() {
            return document.querySelector('html').getAttribute('lang') || 'ru';
        },
    },
};
</script>
